import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { deleteGroups, endDeleteGroups } from '../../store/actions/properties';
import { setGroupFilterIds } from '../../store/actions/query';
import { retrieveRecords } from '../../store/actions/search';

import DeleteGroupsModal from 'components/modals/delete_groups_modal';

export class PropertiesDeleteGroupModal extends React.Component {
  static propTypes = {
    deleteGroups: PropTypes.func.isRequired,
    deletingGroups: PropTypes.array,
    endDeleteGroups: PropTypes.func.isRequired,
    retrieveRecords: PropTypes.func.isRequired,
    setGroupFilterIds: PropTypes.func.isRequired,
  }

  handleDeleteGroups = (groups) => {
    this.props.deleteGroups(groups);
    this.props.setGroupFilterIds([]);
    this.props.retrieveRecords();
  }

  render() {
    return (
      <DeleteGroupsModal
        groups={this.props.deletingGroups}
        shown={this.props.deletingGroups != null}
        onCancel={this.props.endDeleteGroups}
        onDelete={this.handleDeleteGroups}
      />
    );
  }
}

const mapStateToProps = state => ({
  deletingGroups: state.properties.deletingGroups
});

const mapDispatchToProps = {
  deleteGroups,
  endDeleteGroups,
  retrieveRecords,
  setGroupFilterIds,
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesDeleteGroupModal);
